import { songNotes } from './Songs/song1/song1';

export default class ScoreCalculator {
    constructor(noteInterval, musicDelay, key, frameWhichWeShouldAddNote) {
        this.noteInterval = noteInterval;
        this.musicDelay = musicDelay;
        this.key = key;

        this.rockInputEl = document.querySelector('.progress__pointer');
        this.rockInputEl.style.transform = `rotate(${0}deg)`;
        this.score = 0;
        this.hits = 0;
        this.misses = 0;
        this.totalNotes = 0;
        this.rockInput = 0;
        this.isGameWinned = false;
        this.isStartedToCalculate = false;
        this.frameCounter = 0;
        this.noteCounter = 0;
        this.frameWhichWeShouldAddNote = frameWhichWeShouldAddNote;
        this.rightShots = {
        }
    }

    handleWin() {
       return this.isGameWinned;
    }

    checkNote(songNote) {

        if (this.key.isDown(this.key.pos[songNote.pos])?.pressed && !this.key.isDown(this.key.pos[songNote.pos])?.repeat) {
            this.score += 100;

            if (this.rockInput < 20) {
                this.rockInput += 1;
            }

            this.rightShots[songNote.pos] = true;
            setTimeout(() => {
                this.rightShots[songNote.pos] = false;
            }, 250);

        } else {
            if (this.rockInput > -5 && this.rockInput !== 20) {
                this.rockInput -= 1;
            }
        }

        if (this.rockInput === 20) this.isGameWinned = true;

        this.rockInputEl.style.transform = `rotate(${this.rockInput * 2.35}deg)`;
    }

    update() {
        this.frameCounter++;

        if(this.frameCounter === 263){
            this.isStartedToCalculate = true;
            this.frameCounter = 0;
        }

        if(
            this.noteCounter < songNotes.length
            && this.isStartedToCalculate
            && (this.noteCounter % 2 && this.frameCounter === Math.ceil(this.frameWhichWeShouldAddNote)
            || !(this.noteCounter % 2) && this.frameCounter === Math.floor(this.frameWhichWeShouldAddNote))
        ) {
            this.frameCounter = 0;
            this.checkNote(songNotes[this.noteCounter]);
            this.noteCounter++;
        }
    }
}